var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssistant = function SvgAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.75,
    fill: "#fff",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assistant_svg__a)",
    d: "M17.755 16.657c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.646 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.829-1.828l-1.936-.645a.36.36 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828l.645-1.936a.362.362 0 0 1 .687 0l.644 1.936a2.89 2.89 0 0 0 1.829 1.828zm5.099-3.863a.217.217 0 0 1 0 .412l-1.162.387a1.74 1.74 0 0 0-1.098 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162a1.73 1.73 0 0 0-1.097-1.097l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.386a1.73 1.73 0 0 0 1.098-1.097l.387-1.162a.217.217 0 0 1 .412 0l.387 1.162a1.73 1.73 0 0 0 1.097 1.097zm1.049 7.069a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.733.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732l-.773-.258a.146.146 0 0 1-.071-.221.15.15 0 0 1 .07-.053l.774-.258a1.16 1.16 0 0 0 .733-.732l.258-.773a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "assistant_svg__a",
    x1: 27.697,
    x2: 22.269,
    y1: 7.143,
    y2: 22.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2546F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5928ED"
  })))));
};
export default SvgAssistant;